import PropTypes from 'prop-types'
import { VehicleMakeModel } from '../../models/vehicle/vehicle-make-model'

const { MAKE_NAME } = VehicleMakeModel

/**
 * @typedef {Object} VehicleMake
 * @property {string} [makeName] - The make name
 */
export const vehicleMakePropType = PropTypes.shape({
    [MAKE_NAME]: PropTypes.string
})
